import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateEditUsersPage } from './create-edit-users.page';

const routes: Routes = [
  {
    path: '',
    component: CreateEditUsersPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateEditUsersPageRoutingModule {}
